import React from 'react';

import { useSelector, useDispatch } from '../store/hooks';
import { hideOverlayFilters, showOverlayFilters } from '../store/actions/ui';

import ColumnSelector from './columns/selector';
import TableHeader from 'components/table_header/table_header';
import { sortableColumnTypes, excludedColumns, defaultColumnMappings } from 'helpers/research/research_info_mappings';
import { useCurrentColumnProps } from './columns/hooks';

export default function PropertiesTableHeader({ ...props }) {
  const currentColumnProps = useCurrentColumnProps();
  const edgeCrm = useSelector(state => state.features.edgeCrm);
  const showColumnFilters = useSelector(state => state.ui.showColumnFilters);
  const dispatch = useDispatch();

  return (
    <TableHeader
      {...props}
      {...currentColumnProps}
      defaultColumnMappings={defaultColumnMappings}
      excludedColumns={excludedColumns}
      hideOverlayFilters={() => dispatch(hideOverlayFilters())}
      showColumnFilters={showColumnFilters}
      showOverlayFilters={() => dispatch(showOverlayFilters())}
      sortableColumnTypes={sortableColumnTypes}
    >
      {!edgeCrm && <ColumnSelector/>}
    </TableHeader>
  );
}
